<ion-app class="theme-{{global.get('theme')}}">
  <msm-progress-menu></msm-progress-menu>
  <ion-router-outlet id="main-content"></ion-router-outlet>
</ion-app>
